import * as React from 'react';
import { NavProfileToggle } from '@moovly/dashboard-global';

interface TopRightProps {
  onLogout: () => void;
  email: string;
}

const TopRight: React.FC<TopRightProps> = ({ email, onLogout }) => {
  return <NavProfileToggle email={email} onLogout={onLogout} profilePath={'/settings/profile'} />;
};

export default TopRight;
